import MarkdownTextArea from './MarkdownTextArea'

export default MarkdownTextArea
